/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `workout` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class WorkoutMesg : Mesg {
    public constructor() : super("Workout", Profile.MesgNum.WORKOUT)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** message_index. */
    public var messageIndex: UShort?
        get() = getFieldValue(MESSAGE_INDEX_FIELD_NUM) as? UShort
        set(value) = setFieldValue(MESSAGE_INDEX_FIELD_NUM, value)

    /** sport. */
    public var sport: Sport?
        get() = (getFieldValue(SPORT_FIELD_NUM) as? UByte)?.let { Sport.fromValue(it) }
        set(value) = setFieldValue(SPORT_FIELD_NUM, value?.value)

    /** capabilities. */
    public var capabilities: WorkoutCapabilities?
        get() = (getFieldValue(CAPABILITIES_FIELD_NUM) as? UInt)?.let { WorkoutCapabilities.fromValue(it) }
        set(value) = setFieldValue(CAPABILITIES_FIELD_NUM, value?.value)

    /** num_valid_steps. number of valid steps */
    public var numValidSteps: UShort?
        get() = getFieldValue(NUM_VALID_STEPS_FIELD_NUM) as? UShort
        set(value) = setFieldValue(NUM_VALID_STEPS_FIELD_NUM, value)

    /** wkt_name. */
    public var wktName: String?
        get() = getFieldValue(WKT_NAME_FIELD_NUM) as? String
        set(value) = setFieldValue(WKT_NAME_FIELD_NUM, value)

    /** sub_sport. */
    public var subSport: SubSport?
        get() = (getFieldValue(SUB_SPORT_FIELD_NUM) as? UByte)?.let { SubSport.fromValue(it) }
        set(value) = setFieldValue(SUB_SPORT_FIELD_NUM, value?.value)

    /** pool_length, in m. */
    public var poolLength: Double?
        get() = getFieldValue(POOL_LENGTH_FIELD_NUM) as? Double
        set(value) = setFieldValue(POOL_LENGTH_FIELD_NUM, value)

    /** pool_length_unit. */
    public var poolLengthUnit: DisplayMeasure?
        get() = (getFieldValue(POOL_LENGTH_UNIT_FIELD_NUM) as? UByte)?.let { DisplayMeasure.fromValue(it) }
        set(value) = setFieldValue(POOL_LENGTH_UNIT_FIELD_NUM, value?.value)

    /** wkt_description. Description of the workout */
    public var wktDescription: String?
        get() = getFieldValue(WKT_DESCRIPTION_FIELD_NUM) as? String
        set(value) = setFieldValue(WKT_DESCRIPTION_FIELD_NUM, value)

    public companion object {
        public const val MESSAGE_INDEX_FIELD_NUM: UByte = 254u
        public const val SPORT_FIELD_NUM: UByte = 4u
        public const val CAPABILITIES_FIELD_NUM: UByte = 5u
        public const val NUM_VALID_STEPS_FIELD_NUM: UByte = 6u
        public const val WKT_NAME_FIELD_NUM: UByte = 8u
        public const val SUB_SPORT_FIELD_NUM: UByte = 11u
        public const val POOL_LENGTH_FIELD_NUM: UByte = 14u
        public const val POOL_LENGTH_UNIT_FIELD_NUM: UByte = 15u
        public const val WKT_DESCRIPTION_FIELD_NUM: UByte = 17u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[254] = Field("MessageIndex", 254u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[4] = Field("Sport", 4u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[5] = Field("Capabilities", 5u, BaseType.UINT32Z, 1.0, 0.0, "", false)
            fields[6] = Field("NumValidSteps", 6u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[8] = Field("WktName", 8u, BaseType.STRING, 1.0, 0.0, "", false)
            fields[11] = Field("SubSport", 11u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[14] = Field("PoolLength", 14u, BaseType.UINT16, 100.0, 0.0, "m", false)
            fields[15] = Field("PoolLengthUnit", 15u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[17] = Field("WktDescription", 17u, BaseType.STRING, 1.0, 0.0, "", false)
            return fields
        }
    }
}
